import React from "react"
// import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { Link } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
// import HeaderBanner from "../components/header-banner"

const IndexPage = () => (
  <>
    {/* <HeaderBanner/> */}
    <Layout>
      <Seo title="Home" />
      <div className="bg-stone-100">
        <section className="custom-img container flex h-screen min-w-full justify-center bg-cover bg-fixed bg-center   ease-in">
          <div className=" mt-32 flex w-full flex-col justify-center px-12 align-middle md:px-36 lg:px-56">
            <p className="text-center font-Roboto text-6xl font-bold text-slate-200 md:text-8xl lg:text-left">
              reach a new high.
            </p>
            {/* <div className="my-2 h-1 w-full border-t-[1px] border-white"></div> */}

            {/* <div className="bg-black/40 px-4 py-3 font-OpenSans text-base font-semibold italic text-slate-200  md:text-xl">
            <p className=" text-3xl">bouldering [noun] </p>
            <p>/ˈbəʊldərɪŋ/ </p>
            <p className="pt-3">
              A form of rock climbing that is performed on small rock formations
              or artificial rock walls, known as boulders, without the use of
              ropes or harnesses.
            </p>
          </div> */}
          </div>
          {/* <div className="via-black/35 absolute z-0 h-screen w-full bg-gradient-to-b from-transparent via-bump-gray/50 to-bump-gray"></div> */}
        </section>

        <section className="my-auto flex min-h-[50vh]  w-full flex-col justify-center bg-stone-100 py-12 px-12 align-middle md:px-36 lg:px-56">
          <div className=" font-OpenSans text-base font-semibold italic text-stone-700 md:text-xl">
            {/* <p className=" text-3xl">bouldering [noun] </p> */}
            <p className="text-center font-Roboto text-6xl font-bold not-italic text-bump-gray md:text-left md:text-8xl lg:text-left">
              bouldering.
            </p>
            <div className="">
              <p className="text-center text-lg text-stone-500 md:text-left md:text-2xl">
                /ˈbəʊldərɪŋ/{" "}
              </p>
              <p className="pt-3 text-center md:text-left">
                A form of rock climbing that is performed on small rock
                formations or artificial rock walls, known as boulders, without
                the use of ropes or harnesses.
              </p>
            </div>
          </div>

          <div className="mx-auto mt-12 h-full flex-col space-y-6 md:mx-0 md:flex-row md:space-x-6">
            <Link
              to="/first-time"
              className="block max-w-xs border-2 border-transparent  bg-bump-yellow p-3  px-10 text-center font-Roboto text-base font-bold text-bump-gray transition ease-in-out hover:border-bump-gray hover:bg-yellow-300  md:inline-block"
            >
              first time?
            </Link>

            <AnchorLink
              to="/pricing"
              className="block max-w-xs  border-2 border-transparent bg-transparent p-3 px-10  text-center font-Roboto text-base font-medium   text-bump-gray transition  ease-in-out hover:border-bump-gray  md:inline-block"
            >
              pricing
            </AnchorLink>
          </div>
        </section>

        <section className="custom-img3 container flex h-screen min-w-full justify-center bg-cover bg-fixed bg-center   ease-in">
          <div className="my-auto flex w-full flex-col justify-center px-12 align-middle md:px-36 lg:px-56">
            <div className="text-center font-Roboto text-6xl font-bold text-white md:text-8xl lg:text-left">
              take a breather.
            </div>

            {/* <div className="my-2 h-1 w-full border-t-[1px] border-white"></div> */}

            {/* <div className="max-w-2xl font-OpenSans text-base font-thin italic text-white md:text-xl">
              More than just bouldering, we offer a variety of lifestyle
              facilites for you to enjoy. Be it relaxing in our cafe, or
              enjoying a good stretch in our yoga room, you'll never run out of
              things to do here.
            </div> */}

            {/* <div className="mt-12 flex ">
              <Link
                to="/about"
                className="block max-w-xs bg-bump-gray  p-3 px-10  text-center font-Roboto text-base font-bold text-white transition ease-in-out  hover:bg-bump-gray"
              >
                <span>Explore BUMP!</span>
              </Link>
            </div> */}
          </div>

          {/* <div className="absolute z-0 h-full w-full bg-gradient-to-b from-black/30  via-black/10"></div> */}
        </section>

        <section className="custom-img2 container flex  h-screen min-w-full justify-center bg-cover bg-fixed bg-center    ease-in">
          <div className="z-10 my-auto flex w-full flex-col justify-center px-12 align-middle md:px-36 lg:px-56">
            <div className=" text-center font-Roboto text-6xl font-bold text-white md:text-8xl lg:text-left">
              get good.
            </div>

            {/* <div className="my-2 h-1 w-full border-t-[1px] border-white"></div> */}

            {/* <div className="max-w-2xl font-OpenSans text-base font-thin italic text-white md:text-xl">
              At BUMP, your improvement is our priority. Explore our variety of
              classes available for all skill levels!
            </div> */}

            <div className="mx-auto mt-12 h-full flex-col space-y-6 md:mx-0 md:flex-row md:space-x-6">
              <Link
                to="/classes"
                className="block max-w-xs bg-bump-yellow p-3  px-10 text-center  font-Roboto text-base font-bold text-bump-gray transition ease-in-out  hover:bg-bump-yellow  hover:text-white md:inline-block"
              >
                see classes
              </Link>
            </div>
          </div>

          {/* <div className="absolute z-0 h-screen w-full bg-gradient-to-b from-black/20 to-black/60"></div> */}
        </section>

        <section className="z-0">
          <div className="relative h-screen overflow-hidden bg-stone-100 px-12 md:px-36 lg:px-56">
            <div className="pt-16 pb-80 sm:pt-24 sm:pb-40 lg:pt-40 lg:pb-56">
              <div className="relative mx-auto max-w-7xl sm:static">
                <div className="sm:max-w-lg">
                  <p className="font-Roboto text-6xl font-bold text-bump-gray sm:text-8xl">
                    addicted to <span className="text-bump-yellow">chalk</span>?
                  </p>
                  <div className="mt-4 space-y-2 font-OpenSans text-base font-light text-stone-700 lg:text-xl">
                    <p>Still using rentals? That's a no-no!</p>

                    <p>
                      Check out our online shop to get all your essential
                      climbing gear from international brands!
                    </p>
                  </div>
                </div>

                <div>
                  <div className="mt-10">
                    {/* Decorative image grid */}
                    <div
                      aria-hidden="true"
                      className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
                    >
                      <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                        <div className="flex items-center space-x-6 lg:space-x-8">
                          <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                            <div className="h-64 w-44 overflow-hidden rounded-sm sm:opacity-0 lg:opacity-100">
                              <img
                                src="https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-01.jpg"
                                alt=""
                                className="h-full w-full object-cover object-center"
                              />
                            </div>
                            <div className="h-64 w-44 overflow-hidden rounded-sm">
                              <img
                                src="https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-02.jpg"
                                alt=""
                                className="h-full w-full object-cover object-center"
                              />
                            </div>
                          </div>
                          <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                            <div className="h-64 w-44 overflow-hidden rounded-sm">
                              <img
                                src="https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-03.jpg"
                                alt=""
                                className="h-full w-full object-cover object-center"
                              />
                            </div>
                            <div className="h-64 w-44 overflow-hidden rounded-sm">
                              <img
                                src="https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-04.jpg"
                                alt=""
                                className="h-full w-full object-cover object-center"
                              />
                            </div>
                            <div className="h-64 w-44 overflow-hidden rounded-sm">
                              <img
                                src="https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-05.jpg"
                                alt=""
                                className="h-full w-full object-cover object-center"
                              />
                            </div>
                          </div>
                          <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                            <div className="h-64 w-44 overflow-hidden rounded-sm">
                              <img
                                src="https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-06.jpg"
                                alt=""
                                className="h-full w-full object-cover object-center"
                              />
                            </div>
                            <div className="h-64 w-44 overflow-hidden rounded-sm">
                              <img
                                src="https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-07.jpg"
                                alt=""
                                className="h-full w-full object-cover object-center"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <a
                      href="https://bumpbouldering.storehub.me/"
                      className="bg-amber-400 p-3 px-10 font-Roboto text-base  font-bold text-white  transition  ease-in-out hover:bg-bump-yellow"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      shop now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  </>
)

export default IndexPage
